import React, {useRef, useEffect} from "react";
import "./CircleDotHoverButton.css";
import {gsap, Power2} from "gsap";
import {Link} from "react-router-dom";

const CircleDotHoverButton = ({to, children}) => {
  const wrapperRef = useRef(null);
  const btnRef = useRef(null);
  const dotRef = useRef(null);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    const btn = btnRef.current;
    const dot = dotRef.current;

    const updateDotPosition = (e) => {
      const rect = btn.getBoundingClientRect();
      const x = e.pageX - rect.left - window.scrollX;
      const y = e.pageY - rect.top - window.scrollY;

      dot.style.top = `${y}px`;
      dot.style.left = `${x}px`;
    };

    const handleMouseMove = (e) => {
      const rect = wrapper.getBoundingClientRect();
      const relX = e.pageX - rect.left - window.scrollX;
      const relY = e.pageY - rect.top - window.scrollY;

      const movement = 60;

      gsap.to(btn, {
        duration: 1,
        x: ((relX - wrapper.offsetWidth / 2) / wrapper.offsetWidth) * movement,
        y:
          ((relY - wrapper.offsetHeight / 2) / wrapper.offsetHeight) * movement,
        ease: Power2.easeOut,
      });
    };

    const resetButton = () => {
      gsap.to(btn, {
        duration: 1,
        x: 0,
        y: 0,
        ease: Power2.easeOut,
      });
    };

    btn.addEventListener("mouseenter", updateDotPosition);
    btn.addEventListener("mouseout", updateDotPosition);
    wrapper.addEventListener("mousemove", handleMouseMove);
    wrapper.addEventListener("mouseleave", resetButton);

    return () => {
      btn.removeEventListener("mouseenter", updateDotPosition);
      btn.removeEventListener("mouseout", updateDotPosition);
      wrapper.removeEventListener("mousemove", handleMouseMove);
      wrapper.removeEventListener("mouseleave", resetButton);
    };
  }, []);

  return (
    <div className="hover-btn-wrapper" ref={wrapperRef}>
      <Link
        className="btn-circle hover-btn-item hover-btn"
        to={to}
        ref={btnRef}
      >
        <span className="btn-circle-icon">
          <i className="fa-regular fa-arrow-up-right"></i>
          {children}
        </span>
        <i className="btn-circle-dot" ref={dotRef}></i>
      </Link>
    </div>
  );
};

export default CircleDotHoverButton;
